import { Button, Checkbox, Col, Image, Input, Radio, Row } from 'antd';
import { reverse } from 'named-urls';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import routes from '../../../controller/Routes';
const Question = ({
  menuItemValue,
  setMenuItemValue,
  setCurrentQuestionIndex,
  currentQuestionIndex,
  questionData,
  setQuestionData,
}) => {
  const navigate = useNavigate();
  const params = useParams();
  const [nextBtndisable, setNextBtndisable] = useState(false);

  const [answer, setAnswer] = useState([]);
  const handleNext = () => {
    if (
      questionData[menuItemValue]?.questions[currentQuestionIndex + 1] ==
      undefined
    ) {
      if (questionData[menuItemValue + 1]?.questions[0] == undefined) {
        setNextBtndisable(true);
      } else {
        setCurrentQuestionIndex(0);
        setMenuItemValue(menuItemValue + 1);
      }
    } else {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };
  return (
    <>
    {console.log(questionData,"dkdndkndk")}
      <Row className='mt-lg-3 container-lg'>
        <Col lg={15} sm={24} md={20}>
          <div className='fw-semibold fs-6 text-color-custom'>
            Question {currentQuestionIndex + 1}
          </div>
          <div className='fw-bold fs-4 mb-3'>
            {questionData[menuItemValue]?.questions[currentQuestionIndex]?.title}
          </div>
          <div>
            {questionData[menuItemValue]?.questions[currentQuestionIndex]
              ?.imageUrl !== '' && (
              <Image
                src={
                  questionData[menuItemValue]?.questions[currentQuestionIndex]
                    .imageUrl
                }
                className='rounded-3 image-customization mt-2 mb-2'
                height={200}
              />
            )}
          </div>
          <Row gutter={[15, 16]}>
            {questionData[menuItemValue]?.questions[currentQuestionIndex]
              ?.question_type == 'single_choice' ? (
              <Row gutter={[15, 16]}>
                {questionData[menuItemValue]?.questions[
                  currentQuestionIndex
                ]?.options?.map((val, index) => {
                  return (
                    <Col key={index} span={24} className='w-100'>
                      <Radio  checked={val?.is_answer=="True"?true:false} className='w-100'>
                        <Col className='p-2 fw-bold text-muted w-100' span={24}>
                          {val?.text}
                        </Col>
                      </Radio>
                      {val.image_url !== '' && (
                        <Image
                          src={val.image_url}
                          className='rounded-3 image-customization mt-2 mb-2'
                          height={200}
                        />
                      )}
                    </Col>
                  );
                })}
              </Row>
            ) : (
              <Row gutter={[12, 15]}>
                {questionData[menuItemValue]?.questions[
                  currentQuestionIndex
                ]?.options?.map((val, index) => {
                  return (
                    <Col key={index} span={24}>
                      <div className='d-flex w-100 align-items-center gap-2'>
                        <div className='border border-0 border-bottom p-1'>
                          <Checkbox value={index} checked={val?.is_answer=="True"?true:false}>
                            <Col
                              className='p-2 fw-bold text-muted w-100'
                              span={24}
                            >
                              {val?.text}
                            </Col>
                          </Checkbox>
                        </div>
                      </div>
                      {val.image_url !== '' && (
                        <Image
                          src={val.image_url}
                          className='rounded-3 image-customization mt-2 mb-2'
                          height={200}
                        />
                      )}
                    </Col>
                  );
                })}
              </Row>
            )}
          </Row>
        </Col>
      </Row>
      <Row className='mt-5 pb-5'>
        <Col lg={15} sm={24} md={20} className='w-100'>
          <Row className='w-100' justify={'space-between'}>
            <Col lg={4} md={6} sm={6}>
              <Button
                type='text'
                className='w-100 h-auto text-color-custom fw-bold fs-5 p-1 d-flex justify-content-center align-items-center'
                disabled={currentQuestionIndex == 0 ? true : false}
                onClick={() => {
                  setNextBtndisable(false);
                  setCurrentQuestionIndex(currentQuestionIndex - 1);
                }}
              >
                <LeftOutlined />
                Previous
              </Button>
            </Col>
            <Col lg={4} md={6} sm={6}>
              <Button
                type='primary'
                className='w-100 h-auto button-color fs-5 p-1 d-flex justify-content-center align-items-center'
                onClick={() => handleNext()}
                disabled={nextBtndisable}
              >
                Next
                <RightOutlined />
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Question;
